import React, { useEffect } from "react";
import {
  adminMenuDashboardIcon,
  adminMenuInvoiceIcon,
  adminMenuMessageIcon,
  adminMenuMoonIcon,
  adminMenuNotificationIcon,
  adminMenuPropertyIcon,
  adminMenuSettingsIcon,
  lightLogoImg,
  LogoImg,
} from "../../../Constants/Images";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faDollarSign,
  faM,
  faMoneyBill,
} from "@fortawesome/free-solid-svg-icons";
import { FormCheck } from "react-bootstrap";
import { NavLink } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  toogleSideMenuAction,
  toogleThemeAction,
} from "../../../Services/Store/Actions/AuthActions";
import { getLocalData } from "../../../utils/LocalStorage";
import { MENU_STATE_TEXT } from "../../../Constants";
import { toggleMenu } from "../../../Services/Store/Reducers/ThemeReducers";
import { CalendarCheck, HeartIcon, Icon, SunIcon, Wallet } from "lucide-react";

const MenuSidebar = () => {
  const dispatch = useDispatch();
  // const { isMenuOpen } = useSelector((state: any) => state.theme);
  const { isMenuOpen, themeMode } = useSelector((state: any) => state.theme);
  const { messageCount, notificationCount } = useSelector(
    (state: any) => state.auth,
  );

  const checkMenuState = () => {
    const menuState = getLocalData(MENU_STATE_TEXT);
    const newState = menuState && menuState === "false" ? false : true;

    dispatch(toggleMenu({ menuState: newState }));
  };

  const changeViewMode = (mode: string) => {
    console.log("THEME :", mode);

    if (mode === "dark-mode") {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }

    toogleThemeAction(mode, dispatch);
  };

  useEffect(() => {
    checkMenuState();

    if (themeMode === "dark-mode") {
      document.body.classList.add("dark-mode");
    }

    return () => document.body.classList.remove("dark-mode");
  }, []);

  return (
    <div className={`admin-page-sidebar ${!isMenuOpen ? "closed" : ""}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <NavLink to="/user/venues">
            <img
              src={themeMode === "dark-mode" ? lightLogoImg : LogoImg}
              alt=""
            />
          </NavLink>
        </div>

        <div className="menu-hambergar as-Navlink">
          <span
            className="as-link"
            onClick={() => toogleSideMenuAction(dispatch)}
          >
            <FontAwesomeIcon icon={faBars} />
          </span>
        </div>
      </div>

      <div className="sidebar-menu-wrapper">
        <ul>
          {/* <li>
            <NavLink to="/user/dashboard">
              <img
                src={adminMenuDashboardIcon}
                alt=""
                className="menu-icon-img"
              />
              <span>Dashboard</span>
            </NavLink>
          </li> */}

          <li>
            <NavLink to="/user/venues">
              <img
                src={adminMenuPropertyIcon}
                alt=""
                className="menu-icon-img"
              />
              <span>Venues</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/user/favorites">
              <HeartIcon className="menu-icon-img" />
              <span>Favorites</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/user/bookings">
              <CalendarCheck size={45} className="menu-icon-img" />
              <span>Bookings</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/user/payments">
              <img
                src={adminMenuInvoiceIcon}
                alt=""
                className="menu-icon-img"
              />
              <span>Payments</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/user/payouts">
              {/* <FontAwesomeIcon icon={faMoneyBill} className="menu-icon-img" /> */}
              <Wallet className="menu-icon-img" />
              <span>Payouts</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/user/messages">
              <img
                src={adminMenuMessageIcon}
                alt=""
                className="menu-icon-img"
              />
              <span>
                Messages
                <span className="unseen-count">{messageCount}</span>
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/user/notifications">
              <img
                src={adminMenuNotificationIcon}
                alt=""
                className="menu-icon-img"
              />
              <span>
                Notifications{" "}
                <span className="unseen-count">{notificationCount}</span>
              </span>
            </NavLink>
          </li>

          {/* <li>
            <NavLink to="/user/settings">
              <img
                src={adminMenuSettingsIcon}
                alt=""
                className="menu-icon-img"
              />
              <span>Settings</span>
            </NavLink>
          </li> */}
        </ul>
      </div>

      <div className="dark-mode-setting">
        <div className="dark-mode-item">
          {themeMode === "light-mode" && (
            <>
              <SunIcon size={18} className="menu-icon-img" />
              <span>Light Mode</span>
            </>
          )}
          {themeMode === "dark-mode" && (
            <>
              <img src={adminMenuMoonIcon} alt="" className="menu-icon-img" />
              <span>Dark Mode</span>
            </>
          )}
        </div>

        <FormCheck
          type="switch"
          checked={themeMode === "dark-mode" ? true : false}
          onChange={(e) =>
            changeViewMode(e.target.checked ? "dark-mode" : "light-mode")
          }
        />
      </div>
    </div>
  );
};

export default MenuSidebar;
